import React from 'react';
import { Home, Wind, ListChecks, FileCheck, Microscope, ArrowRight, Phone, MessageSquare } from 'lucide-react';
import { OutlineButton } from './common/Button';
export function ServicesGrid() {
  return <section id="services" className="py-16 bg-white" data-id="element-339">
      <div className="container mx-auto px-4" data-id="element-340">
        <div className="text-center mb-12" data-id="element-341">
          <div className="flex justify-center mb-4" data-id="element-342">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ft96BQXpN2jabTTRnFyFuA/crowninspectionlogosmall.png" alt="Crown icon" className="w-10 h-10" data-id="element-343" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B365D] mb-4" data-id="element-344">
            Professional Inspection Services
          </h2>
          <p className="text-[#2C3E50] text-lg max-w-3xl mx-auto" data-id="element-345">
            Comprehensive inspection services to protect your investment and
            provide peace of mind.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-346">
          <ServiceCard icon={<Home size={40} className="text-[#0077BE]" data-id="element-348" />} title="Comprehensive Home Inspections" description="Thorough evaluation of all major systems and components of the property, including structural, electrical, plumbing, HVAC, roof, and more." turnaround="Same-day reports" data-id="element-347" />
          <ServiceCard icon={<Wind size={40} className="text-[#0077BE]" data-id="element-350" />} title="Wind Mitigation Inspections" description="Identify wind-resistant features that may qualify you for insurance discounts up to 40% on your homeowner's policy." turnaround="Same-day reports" highlight="Save up to 40% on insurance" data-id="element-349" />
          <ServiceCard icon={<ListChecks size={40} className="text-[#0077BE]" data-id="element-352" />} title="4-Point Inspections" description="Required by most insurance companies, focusing on electrical, plumbing, HVAC, and roofing." turnaround="Same-day reports" data-id="element-351" />
          <ServiceCard icon={<FileCheck size={40} className="text-[#0077BE]" data-id="element-354" />} title="Roof Certificates" description="Verify the condition and remaining life expectancy of your roof." turnaround="Same-day reports" data-id="element-353" />
          <ServiceCard icon={<Microscope size={40} className="text-[#0077BE]" data-id="element-356" />} title="Mold Inspections" description="Professional assessment with lab testing to identify mold issues and recommend remediation strategies." turnaround="Lab results in 3-5 days" data-id="element-355" />
          <div className="bg-gradient-to-br from-[#1B365D] to-[#2A4A7F] text-white rounded-lg p-8 shadow-lg flex flex-col justify-between h-full relative" data-id="element-357">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ft96BQXpN2jabTTRnFyFuA/crowninspectionlogosmall.png" alt="Crown icon" className="w-8 h-8 absolute top-4 right-4 opacity-50" data-id="element-358" />
            <div data-id="element-359">
              <h3 className="text-2xl font-bold mb-4" data-id="element-360">
                Detailed Video from our drone
              </h3>
              <p className="mb-6" data-id="element-361">
                We will supply detailed photos and videos of your roof with our
                state of the art drone. Insuring you can see what we see.
              </p>
              <div className="text-sm text-[#D4AF37] font-medium" data-id="element-362">
                Same-day report
              </div>
            </div>
            <div className="mt-4 flex gap-2" data-id="element-363">
              <a href="tel:2396997080" className="flex items-center justify-center bg-[#D4AF37] hover:bg-[#C09F2F] text-[#1B365D] py-3 px-6 rounded-md font-bold transition-colors duration-200 flex-1" data-id="element-364">
                <Phone size={18} className="mr-2" data-id="element-365" />
                Call
              </a>
              <a href="sms:+12396997080?body=Hello, I'm interested in your inspections services." className="flex items-center justify-center bg-white hover:bg-gray-100 text-[#1B365D] py-3 px-6 rounded-md font-bold transition-colors duration-200 flex-1" data-id="element-366">
                <MessageSquare size={18} className="mr-2" data-id="element-367" />
                Text
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  turnaround: string;
  highlight?: string;
}
function ServiceCard({
  icon,
  title,
  description,
  turnaround,
  highlight
}: ServiceCardProps) {
  return <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-lg flex flex-col h-full transform hover:shadow-xl transition-shadow duration-300" data-id="element-368">
      {highlight && <div className="bg-[#D4AF37] text-[#1B365D] text-center py-1 font-bold text-sm" data-id="element-369">
          {highlight}
        </div>}
      <div className="p-6 flex-grow" data-id="element-370">
        <div className="mb-4" data-id="element-371">{icon}</div>
        <h3 className="text-xl font-bold text-[#1B365D] mb-2" data-id="element-372">{title}</h3>
        <p className="text-[#2C3E50] mb-4" data-id="element-373">{description}</p>
        <div className="flex justify-end text-sm text-gray-600 mb-4" data-id="element-374">
          <div data-id="element-375">{turnaround}</div>
        </div>
      </div>
      <div className="border-t border-gray-200 p-4 bg-gray-50 flex justify-end gap-2" data-id="element-376">
        <a href="tel:2396997080" className="inline-flex items-center justify-center bg-[#0077BE] text-white py-2 px-4 rounded-md text-sm font-medium hover:bg-[#0065a1] transition-colors duration-200" data-id="element-377">
          <Phone size={14} className="mr-1" data-id="element-378" />
          Call Now
        </a>
        <a href="sms:+12396997080?body=Hello, I'm interested in your inspections services." className="inline-flex items-center justify-center bg-[#D4AF37] text-[#1B365D] py-2 px-4 rounded-md text-sm font-medium hover:bg-[#C09F2F] transition-colors duration-200" data-id="element-379">
          <MessageSquare size={14} className="mr-1" data-id="element-380" />
          Text Us
        </a>
      </div>
    </div>;
}